declare var krt: any;

type CustomEventParameter = {
  event_name: string;
  content_name: string;
  message: string;
};

class CustomEventHandling {
  sendEvent({ event_name, content_name, message }: CustomEventParameter) {
    if ('krt' in window) {
      krt('send', event_name, {
        content_name: content_name,
        message: message
      });
    } else {
      console.info(JSON.stringify({ event_name, content_name, message }, null, '\t'));
      console.info('karteタグが読み込まれていません。');
    }
  }
}

export default new CustomEventHandling();
